import "@mantine/core/styles.css";
import "@mantine/notifications/styles.css";
import "./styles/index.css";
import "./styles/layout.css";

import { StrictMode } from "react";
import ReactDOM from "react-dom/client";

import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { MantineProvider, ColorSchemeScript } from "@mantine/core";
import { Notifications } from "@mantine/notifications";
import { BrowserRouter } from "react-router-dom";

import AppRoutes from "./routes/index";
import { AuthProvider } from "@admin/contexts/auth-provider";
import { useSocketInitialization } from "@admin/hooks/use-socket-initialization";

import { theme } from "./theme";

const queryClient = new QueryClient();

// Simple component that handles socket initialization without causing infinite loops
const SocketInitializer = () => {
	useSocketInitialization();
	// Return null so this doesn't render anything
	return null;
};

ReactDOM.createRoot(document.getElementById("root")!).render(
	<>
		<StrictMode>
			<ColorSchemeScript defaultColorScheme="auto" />
			<QueryClientProvider client={queryClient}>
				<MantineProvider defaultColorScheme="auto" theme={theme}>
					<Notifications position="top-right" zIndex={2000} />
					<BrowserRouter>
						<AuthProvider>
							<AppRoutes />
							{/* Socket initializer inside AuthProvider but outside routes */}
							<SocketInitializer />
						</AuthProvider>
					</BrowserRouter>
				</MantineProvider>
			</QueryClientProvider>
		</StrictMode>
	</>
);
